import React, { useEffect } from 'react';
import { useIdentificationContext } from '../../IdentificationContext';
import { ResetPasswordStepForm } from './ResetPasswordStepForm';
import { useDoubleStepResetPasswordExperiment } from './hooks';

interface OnSubmitArgs {
    redirectUrl?: string;
}

interface ResetPasswordStepProps {
    goBack?: () => void;
}

export const ResetPasswordStep = ({ goBack }: ResetPasswordStepProps) => {
    const {
        navigateToRedirectUrl,
        setRedirectUrl,
        email,
        setEmail,
        closeModal,
        inLynxesIdentificationResetPasswordRollout,
        inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout,
        isModal,
        variant,
    } = useIdentificationContext();

    const doubleStepResetPasswordExperimentGroup = useDoubleStepResetPasswordExperiment({
        rolloutResult: inLynxesIdentificationResetPasswordRollout,
        mixpanelRecordingsRolloutResult: inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout,
    });

    useEffect(() => {
        const cleanupOnUnmount = () => setEmail('');

        return cleanupOnUnmount;
    }, [setEmail]);

    const handleDoneClick = () => {
        if (!isModal) {
            window.location.assign('/');
            return;
        }
        closeModal?.();
    };

    const onSubmit = ({ redirectUrl }: OnSubmitArgs) => {
        if (redirectUrl) setRedirectUrl(redirectUrl);

        navigateToRedirectUrl();
    };

    return (
        <ResetPasswordStepForm
            email={email}
            doubleStepResetPasswordExperimentGroup={doubleStepResetPasswordExperimentGroup}
            handleDoneClick={handleDoneClick}
            onSubmit={onSubmit}
            variant={variant}
            goBack={goBack}
        />
    );
};
